var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-wrap",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hideAlert($event)}}},[_c('div',{staticClass:"alert-box"},[_vm._t("title"),_vm._v(" "),_vm._t("content"),_vm._v(" "),_c('p',{staticClass:"btn",on:{"click":_vm.hideAlert}},[_vm._v("好的，知道了")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e5f1904","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/CommonAlert.vue
// module id = null
// module chunks = 